import listItemCoverPlaceholder from "./list-item-cover-placeholder.png";
import listItemFramePlaceholder from "./list-item-frame-placeholder.png";

export default {
  listItemCoverPlaceholder,
  listItemFramePlaceholder,
};
